import { Divider, ScrollArea } from "@mantine/core";
import {
  IconCalculatorFilled,
  IconUsersGroup,
  IconHomeFilled,
  IconFileStack,
  IconClockFilled,
} from "@tabler/icons-react";
import LinkGroup, { LinksGroupProps } from "./LinksGroup/LinkGroup";
import { useLocation } from "react-router-dom";
import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { inAppPaths } from "src/App";
import { getI18t } from "src/pages/i18n/i18n";

type Props = { onItemClick?: () => void };

function SideBar({ onItemClick }: Props) {
  const location = useLocation();
  const t = getI18t(
    useTranslation(undefined, {
      keyPrefix: "nav.sideBar",
    }).t
  );

  const links = useMemo((): (LinksGroupProps | "divider")[] => {
    const links: (LinksGroupProps | "divider")[] = [
      {
        label: t("tabs.devices"),
        icon: IconCalculatorFilled,
        path: inAppPaths.devices,
      },
      {
        label: t("tabs.members"),
        icon: IconUsersGroup,
        path: inAppPaths.members,
      },
      {
        label: t("tabs.logs.label"),
        icon: IconFileStack,
        path: [
          {
            label: t("tabs.logs.sub.activity"),
            path: inAppPaths.logs.activity,
          },
          { label: t("tabs.logs.sub.sensor"), path: inAppPaths.logs.sensor },
          { label: t("tabs.logs.sub.system"), path: inAppPaths.logs.system },
        ],
      },
      {
        label: t("tabs.timeWindowGroups"),
        icon: IconClockFilled,
        path: inAppPaths.timeWindowGroups,
      },
      "divider",
      {
        label: t("tabs.groups"),
        icon: IconHomeFilled,
        path: inAppPaths.groups,
      },
    ];
    links.forEach((i) => {
      if (i == "divider") {
        return;
      }
      if (Array.isArray(i.path)) {
        i.path.forEach(
          (si) => (si.isSelected = location.pathname.startsWith(si.path))
        );
      } else if (i.path != null) {
        i.isSelected = location.pathname.startsWith(i.path);
      }
    });
    return links;
  }, [t, location]);

  const linkItems = links.map((item, i) =>
    item == "divider" ? (
      <Divider key={`divider-${i}`} className="!border-t-2 my-1 !border-t-[#e5e7eb]"/>
    ) : (
      <LinkGroup {...item} key={item.label} onClick={onItemClick} />
    )
  );

  // return <Outlet/>;

  return (
    <nav className="h-full w-60 pb-0 flex flex-shrink-0 flex-col border-r-2 bg-white">
      <ScrollArea className="flex-1">
        <div>{linkItems}</div>
      </ScrollArea>
    </nav>
  );
}

export default memo(SideBar);
